import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup, makeStyles, createStyles, Grid } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

const useFormControlStyles = makeStyles(() =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "row",
        },
        firstFormControlLabelStyle: {
            marginRight: 64,
        },
    }),
);

export const ModificationCellarForm: FC = () => {
    const classes = useStyles();
    const formControlStyles = useFormControlStyles();
    const { values, setValues } = useFormModel<ChangeNames.MODIFICATION_CELLAR>();

    const convertValue = (): string => {
        if (values.modificationCellar.value.yes) return "withCellar";
        if (values.modificationCellar.value.no) return "withoutCellar";
        return "";
    };

    const selection = convertValue();

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Gebäudeaufbau
                </h4>
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            setValues(values => {
                                values.modificationCellar.value = {
                                    yes: v.includes("withCellar"),
                                    no: v.includes("withoutCellar"),
                                };
                            });
                        }}
                    >
                        <Grid container spacing={7} className={formControlStyles.container}>
                            <Grid item xs={8} sm={12} md={12}>
                                <FormControlLabel
                                    className={formControlStyles.firstFormControlLabelStyle}
                                    value="withoutCellar"
                                    control={<Radio />}
                                    label="Ohne Keller"
                                    error={values.modificationCellar.error !== null}
                                />
                                <FormControlLabel
                                    value="withCellar"
                                    control={<Radio />}
                                    label="Mit Keller"
                                    error={values.modificationCellar.error !== null}
                                />
                            </Grid>
                        </Grid>
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
